import Store from '@/store'
import {setStoreState} from '../../utils'
import orderService from '@/services/order'
const productActions = {
  async getShopcarNums() {
    try {
      const res = await orderService.getUserCartNum()
      setStoreState('products', 'shopcarNums', res?.result)
      return res?.result
    } catch (error: any) {
      throw error
    }
  },
  async setShipProducts(context, shipProducts): Promise<any> {
    try {
      console.log('token',shipProducts);
      setStoreState('products', 'shipProducts', shipProducts)
    } catch (error: any) {
      console.log(error)
      throw error
    }
  },
  // buyNowData
  async setBuyNowData(context, buyNowData): Promise<any> {
    try {
      console.log('token',buyNowData);
      setStoreState('products', 'buyNowData', buyNowData)
    } catch (error: any) {
      console.log(error)
      throw error
    }
  },
  
}

type productActionsType = typeof productActions

export {productActionsType}
export default productActions
